import * as React from "react";
import FormButton from "@src/components/ui/FormButton";
import FormImageButton from "@src/components/ui/FormImageButton";

interface Props {
    title: string,
    pretitle?: string,
    image: string,
    icon?: string,
    description?: string,
    post: string,
    action: string,
    actionicon: string,
    onClick?: any,
    iconSize: any,
    iconColor: any,
    preButton?: any,
    preOnClick?: any,
}

interface State {

}

export default class Message extends React.Component<Props, State> {

    render() {
        let title = "title";

        if(this.props.pretitle) {
            title = "title-pre";
        }
        
        return (
            <div className="messageView">
                <div className="header-image">
                    {
                        (this.props.icon !== undefined &&
                        this.props.icon !== null) ?
                            (<span className={ this.props.icon } style={ { fontSize: this.props.iconSize, color: this.props.iconColor } } > </span>)
                            : (<img src={this.props.image} />)
                    }
                </div>
                {
                    this.props.pretitle && (
                        <h4 className="pre-title">{this.props.pretitle}</h4>
                    )
                }
                <h2 className={`${title}`}>{this.props.title}</h2>
                {
                    this.props.description && (
                        <h4 className="description" dangerouslySetInnerHTML={{__html: this.props.description}} />
                    )
                }
                {
                    this.props.preButton && (
                        <button className={"btn main lg"} onClick={() => { if (this.props.preOnClick) this.props.preOnClick(); }}><span dangerouslySetInnerHTML={{__html: this.props.preButton}} /></button>
                    )
                }
                <hr />
                <h4 className="description">{this.props.post}</h4>
                <div className="button-bottom">
                    <FormImageButton type={"button"} text={this.props.action} icon={this.props.actionicon} onClick={this.props.onClick}></FormImageButton>
                </div>
                {this.props.children || null}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/Message.tsx